<template>
    <v-card>
        <v-form>
            <v-card-title>
                <h2 class="form__headline">New Client</h2>
            </v-card-title>
            <v-card-text>
                <v-container class="my-0">
                    <v-row class="my-0">
                        <v-col cols="12">
                            <v-text-field
                                    v-model="name"
                                    class="my-0"
                                    label="Type a name of the client"
                                    required>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-text>
                <v-btn class="md2 offset-md-10" color="primary" @click="createDomain">Add</v-btn>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "ClientsListNewItemForm",
        data: () => ({
            name: ''
        }),
        methods: {
            closeDialog: function ($e) {
                this.$emit('dialogClosed', $e)
            },
            createDomain: function () {
                if (this.name) {
                    axios.post('/domains', {"name": this.name}).then(resp => {
                        this.name = '';
                        this.$emit('dialogClosed')
                    });

                }
            }
        }
    }
</script>

<style scoped>

</style>
